import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList } from "vue"
import _imports_0 from '@icon/x-circle.svg'
import _imports_1 from '@icon/spinner.svg'
import _imports_2 from '@icon/spinner-gradient-dark.svg'
import _imports_3 from '@icon/spinner-gradient.svg'
import _imports_4 from '@icon/trash.svg'


const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "custom-file__desc" }
const _hoisted_3 = { class: "custom-file__content" }
const _hoisted_4 = { class: "custom-file__row" }
const _hoisted_5 = { class: "custom-file__row-item custom-file__row-right" }
const _hoisted_6 = { class: "desc_label desc_normal custom-file_time-ago" }
const _hoisted_7 = { class: "custom-file__sub-row" }
const _hoisted_8 = ["id", "onClick"]
const _hoisted_9 = { class: "custom-file__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilePic = _resolveComponent("FilePic")!
  const _component_ProgressLoadingLine = _resolveComponent("ProgressLoadingLine")!
  const _component_icon = _resolveComponent("icon")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_FileDownloadPic = _resolveComponent("FileDownloadPic")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_DropdownTooltip = _resolveComponent("DropdownTooltip")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.file.id,
    class: _normalizeClass(["custom-file", [
      `custom-file_${_ctx.fileMarkup}`,
      {
        'is-deleted': _ctx.isRemoved,
        'is-previewable': _ctx.isPreviewable,
        'is-not-openable': _ctx.isNotOpenable
      }
    ]])
  }, [
    _createElementVNode("div", {
      class: "custom-file__in",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showImage()))
    }, [
      (_ctx.isElType)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_FilePic, {
              isRemoved: _ctx.isRemoved,
              fileName: _ctx.file.name
            }, null, 8, ["isRemoved", "fileName"]),
            _createElementVNode("span", _hoisted_2, [
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "custom-file__name",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showImage()), ["prevent","stop"]))
              }, [
                _createTextVNode(_toDisplayString(_ctx.file.name), 1)
              ])), [
                [_directive_tooltip, {
              content: _ctx.file.name,
              theme: 'info-tooltip',
              placement: 'bottom',
              popperClass: 'custom-file__tooltip'
            }]
              ]),
              (!_ctx.isRemoved)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["custom-file__meta", { 'is-error': _ctx.isOverSizeLimit }])
                    }, _toDisplayString(_ctx.downloadStatus ? _ctx.$t(`fileDownloadStatus.${_ctx.downloadStatus}`) : _ctx.fileMaxSize), 3),
                    _createVNode(_component_ProgressLoadingLine, {
                      class: _normalizeClass(["custom-file__progress", [{ 'is-hidden': (_ctx.progress === 0 && !_ctx.isUploading) || _ctx.isOverSizeLimit }]]),
                      progress: _ctx.progress
                    }, null, 8, ["class", "progress"]),
                    (_ctx.removeButton)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "custom-file__remove",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('remove', _ctx.file)), ["stop"]))
                        }, [
                          _createVNode(_component_icon, {
                            data: _imports_0,
                            fill: false,
                            color: "currentColor",
                            width: "var(--icon-16)",
                            height: "var(--icon-16)"
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.isRemoved && !_ctx.removeButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: _normalizeClass(["custom-file__download", {
            'is-downloading': _ctx.downloadStatus,
            'is-preparing': _ctx.downloadStatus === 'preparing'
          }]),
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFileDownload && _ctx.onFileDownload(...args)), ["prevent","stop"]))
                }, [
                  (_ctx.downloadStatus)
                    ? (_openBlock(), _createBlock(_component_Spinner, {
                        key: 0,
                        loading: true,
                        className: "custom-file__download-spinner"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.downloadStatus === 'preparing')
                            ? (_openBlock(), _createBlock(_component_icon, {
                                key: 0,
                                data: _imports_1,
                                width: "var(--icon-24)",
                                height: "var(--icon-24)",
                                color: "var(--monochrome02to36)",
                                class: "spin-animation"
                              }))
                            : (_ctx.isDark)
                              ? (_openBlock(), _createBlock(_component_icon, {
                                  key: 1,
                                  data: _imports_2,
                                  original: "",
                                  width: "var(--icon-24)",
                                  height: "var(--icon-24)",
                                  class: "spin-animation"
                                }))
                              : (_openBlock(), _createBlock(_component_icon, {
                                  key: 2,
                                  data: _imports_3,
                                  original: "",
                                  width: "var(--icon-24)",
                                  height: "var(--icon-24)",
                                  class: "spin-animation"
                                }))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_FileDownloadPic, { key: 1 }))
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.isRemoved)
              ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
                  key: 1,
                  weight: "500",
                  size: "extra-small",
                  className: "custom-file__deleted-info",
                  color: "monochrome-05",
                  darkColor: "monochrome-04"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Deleted by " + _toDisplayString(_ctx.file.deletedBy?.fullName), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isLineType)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showImage()), ["prevent","stop"]))
            }, [
              _createVNode(_component_FilePic, {
                isRemoved: _ctx.isRemoved,
                fileName: _ctx.file.name
              }, null, 8, ["isRemoved", "fileName"])
            ]),
            (!_ctx.isRemoved)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "custom-file__row-item custom-file__row-left",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.showImage()), ["prevent","stop"]))
                      }, [
                        _withDirectives((_openBlock(), _createBlock(_component_BaseSubHeading, {
                          weight: "400",
                          size: "medium",
                          className: "custom-file__cut-name",
                          color: "monochrome-07"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.file.name), 1)
                          ]),
                          _: 1
                        })), [
                          [_directive_tooltip, {
                    content: _ctx.file.name,
                    theme: 'info-tooltip',
                    placement: 'bottom',
                    popperClass: 'custom-file__tooltip'
                  }]
                        ]),
                        _createVNode(_component_BaseSubHeading, {
                          weight: "500",
                          size: "extra-small",
                          className: "custom-file__size",
                          color: "monochrome-05",
                          darkColor: "monochrome-04"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.downloadStatus ? _ctx.$t(`fileDownloadStatus.${_ctx.downloadStatus}`) : _ctx.fileSize), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["custom-file__download", {
                    'is-downloading': _ctx.downloadStatus,
                    'is-preparing': _ctx.downloadStatus === 'preparing'
                  }]),
                          onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFileDownload && _ctx.onFileDownload(...args)), ["prevent","stop"]))
                        }, [
                          (_ctx.downloadStatus)
                            ? (_openBlock(), _createBlock(_component_Spinner, {
                                key: 0,
                                loading: true,
                                className: "custom-file__download-spinner"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.downloadStatus === 'preparing')
                                    ? (_openBlock(), _createBlock(_component_icon, {
                                        key: 0,
                                        data: _imports_1,
                                        width: "var(--icon-24)",
                                        height: "var(--icon-24)",
                                        color: "var(--monochrome02to36)",
                                        class: "spin-animation"
                                      }))
                                    : (_ctx.isDark)
                                      ? (_openBlock(), _createBlock(_component_icon, {
                                          key: 1,
                                          data: _imports_2,
                                          original: "",
                                          width: "var(--icon-24)",
                                          height: "var(--icon-24)",
                                          class: "spin-animation"
                                        }))
                                      : (_openBlock(), _createBlock(_component_icon, {
                                          key: 2,
                                          data: _imports_3,
                                          original: "",
                                          width: "var(--icon-24)",
                                          height: "var(--icon-24)",
                                          class: "spin-animation"
                                        }))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_FileDownloadPic, { key: 1 }))
                        ], 2),
                        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _createVNode(_component_BaseSubHeading, {
                            weight: "400",
                            size: "large",
                            color: "monochrome-05",
                            darkColor: "monochrome-04"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.timeAgo), 1)
                            ]),
                            _: 1
                          })
                        ])), [
                          [
                            _directive_tooltip,
                            { content: _ctx.fileCreateDate, theme: 'info-tooltip' },
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_ProgressLoadingLine, {
                        class: _normalizeClass(["custom-file__progress", [{ 'is-hidden': (_ctx.progress === 0 && !_ctx.isUploading) || _ctx.isOverSizeLimit }]]),
                        progress: _ctx.progress
                      }, null, 8, ["class", "progress"])
                    ])
                  ]),
                  _createVNode(_component_Avatar, {
                    src: _ctx.fileOwner.pictureUrl,
                    gap: _ctx.fileOwner.getInitials()
                  }, null, 8, ["src", "gap"]),
                  _createVNode(_component_DropdownTooltip, {
                    skidding: 8,
                    iconSize: "md",
                    placement: "bottom-end",
                    class: _normalizeClass(["custom-file__menu", { 'is-hidden': _ctx.hideMenu }]),
                    disabled: _ctx.hideMenu,
                    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    "tooltip-content": _withCtx(({ hide }) => [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moreOptions, (option, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, [
                            _createElementVNode("button", {
                              id: option.id,
                              class: "dropdownTooltip_remove dropdownTooltip",
                              onClick: _withModifiers(($event: any) => (_ctx.deleteFile(hide)), ["prevent"])
                            }, [
                              _createVNode(_component_icon, {
                                data: _imports_4,
                                width: "1.5em",
                                height: "1.5em",
                                fill: true,
                                color: "#7D92A7"
                              }),
                              _createTextVNode(" " + _toDisplayString(option.label), 1)
                            ], 8, _hoisted_8)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["class", "disabled"])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives((_openBlock(), _createBlock(_component_BaseSubHeading, {
                      weight: "400",
                      size: "medium",
                      className: "custom-file__cut-name",
                      color: "monochrome-07"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.file.name), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_tooltip, {
                content: _ctx.file.name,
                theme: 'info-tooltip',
                placement: 'bottom',
                popperClass: 'custom-file__tooltip'
              }]
                    ])
                  ]),
                  _createVNode(_component_BaseSubHeading, {
                    weight: "500",
                    size: "small",
                    className: "custom-file__deleted-info",
                    color: "monochrome-05",
                    darkColor: "monochrome-04"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Deleted by " + _toDisplayString(_ctx.file.deletedBy?.fullName), 1)
                    ]),
                    _: 1
                  })
                ], 64))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}